import { useEffect } from 'react';
export default function ExternalRedirect(props) {
    useEffect(() => {
        window.location.href = props.to;
    }, [props.to]);
    return null;
}
//# sourceMappingURL=ExternalRedirect.js.map